import React from 'react'
// import { Link } from 'react-router-dom'

const Home = () => {
  return (<>
    <div className="homeWrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: '700px', margin: '0 auto' }}>
      <h1>Are most pathways related to Alzheimer’s disease pathogenesis?</h1>
      <h2 style={{ fontSize: '16px', marginBottom: '0px', marginTop: '0px' }}>Authors</h2>
      <p style={{ fontSize: '12px', marginTop: '0px', width: '450px', textAlign: 'center' }}>Sarah L Morgan, Pourya Naderi, Katjuša Koler, Yered Pita-Juarez1, Ioannis S Vlachos, Lars Bertram, and Winston Hide.</p>

      <h1 style={{ marginTop: '50px' }}>Abstract</h1>
      <hr className="faqHR" />

      <h2 style={{ marginBottom: '5px', marginTop: '5px' }}>Background</h2>
      <p style={{ marginTop: '0px' }}>Alzheimer’s disease (AD) is a complex neurodegenerative disorder. The relative contribution of the numerous underlying functional mechanisms is poorly understood.</p>
      <hr className="faqHR" />

      <h2 style={{ marginBottom: '5px', marginTop: '5px' }}>Methods</h2>
      <p style={{ marginTop: '0px' }}>To comprehensively understand the context and distribution of pathways that contribute to AD, we performed text-mining to generate an exhaustive, systematic assessment of the breadth and diversity of biological pathways within a corpus of 206,324 dementia publication abstracts.</p>
      <hr className="faqHR" /> 
      
      <h2 style={{ marginBottom: '5px', marginTop: '5px' }}>Results</h2>
      <p style={{ marginTop: '0px' }}>A total of 91% (325/335) of KEGG pathways have publications containing an association via at least 5 papers, while 63% of pathway terms have at least 50 papers providing a clear association with AD. Despite major technological advances, the same set of top-ranked pathways have been consistently related to AD for 30 years, including: AD, immune system, metabolic pathways, cholinergic synapse, long-term depression, proteasome, diabetes, cancer and chemokine signaling. AD pathways studied appear biased: animal model and human subject studies prioritize different AD pathways. Surprisingly, human genetic discoveries and drug targeting are not enriched in the most frequently studied pathways.</p>
      <hr className="faqHR" />
      
      <h2 style={{ marginBottom: '5px', marginTop: '5px' }}>Conclusion</h2>
      <p style={{ marginTop: '0px' }}>Our findings suggest that not only is this disorder incredibly complex, but that its functional reach is nearly global. As a consequence of our study, research results can now be assessed in the context of the wider AD literature, supporting the design of drug therapies that target a broader range of mechanisms. </p>
      <hr className="faqHR" />

      <h1 style={{ marginBottom: '10px' }}>Cite Us</h1>
      <p style={{ marginTop: '0px' }}>citation information</p>
      <hr className="faqHR" />
    </div>
  </>)
}

export default Home